<script>
import { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbBtn } from 'mdbvue'
import {
  addReport as apiAddReport,
  editReport as apiEditReport
} from '@/api/api'
import { appConfig } from '@/configs/config'
const MODE_ADD = 'add'
const MODE_EDIT = 'edit'
// import faker from 'faker'
const initialFormData = {
  date: '',
  supplier: '',
  portal: '',
  target: '',
  service: '',
  product: '',
  materials: '',
  // creation: '',
  title: '',
  display: '',
  click: '',
  open: '',
  cost: '',
  visual: null
}
// const initialFormData = {
//   date: faker.date.past().toISOString(),
//   supplier: faker.company.companyName(),
//   portal: faker.internet.domainName(),
//   target: faker.name.jobArea(),
//   service: faker.commerce.product(),
//   product: faker.commerce.productName(),
//   materials: faker.random.word(),
//   creation: faker.random.word(),
//   title: faker.random.word(),
//   display: faker.random.number().toString(),
//   click: faker.random.number().toString(),
//   open: faker.random.number().toString(),
//   cost: faker.random.number().toString()
// }
export default {
  created () {
    this.$parent.$on('showAddReportModal', () => {
      this.mode = MODE_ADD
      this.initEmptyForm()
      this.showModal()
    })
    this.$parent.$on('showEditReportModal', ({ reportId }) => {
      this.mode = MODE_EDIT
      this.reportId = reportId
      this.initEditForm({ reportId })
      this.showModal()
    })
    this.$store.dispatch('suppliers/RETRIEVE_SUPPLIERS')
    this.$store.dispatch('portals/RETRIEVE_PORTALS')
    this.$store.dispatch('targets/RETRIEVE_TARGETS')
    this.$store.dispatch('services/RETRIEVE_SERVICES')
    this.$store.dispatch('products/RETRIEVE_PRODUCTS')
  },
  data: () => ({
    isModalVisible: false,
    mode: null,
    reportId: null,
    form: {},
    errors: {},
    isFormSubmitted: false,
    isAjaxLoaderVisible: false
  }),
  computed: {
    suppliers () {
      return this.$store.getters['suppliers/SUPPLIERS']
    },
    portals () {
      return this.$store.getters['portals/PORTALS']
    },
    targets () {
      return this.$store.getters['targets/TARGETS']
    },
    services () {
      return this.$store.getters['services/SERVICES']
    },
    products () {
      return this.$store.getters['products/PRODUCTS']
    },
    isEditMode () {
      return this.mode === MODE_EDIT
    },
    modalHeaderTitle () {
      return this.isEditMode
        ? 'Edycja raportu'
        : 'Dodaj raport'
    },
    previewSrc () {
      if (this.form.visual) {
        return URL.createObjectURL(this.form.visual)
      }
      else if (this.reportId) {
        const report = this.$store.getters['reports/REPORT']({ reportId: this.reportId })
        if (report.visual) {
          return appConfig.apiUrl + '/imagecache?query=' + report.visual
        }
      }
      return ''
    }
  },
  methods: {
    showModal () {
      this.isModalVisible = true
    },
    closeModal () {
      this.isModalVisible = false
      this.resetData()
    },
    initEmptyForm () {
      this.form = { ...initialFormData }
    },
    initEditForm ({ reportId }) {
      const report = this.$store.getters['reports/REPORT']({ reportId })
      this.form = {
        date: report.date.toISOString(),
        supplier: report.supplier,
        portal: report.portal,
        target: report.target,
        service: report.service,
        product: report.product,
        materials: report.materials,
        // creation: report.creation,
        title: report.title,
        display: report.display.toString(),
        click: report.click.toString(),
        open: report.open.toString(),
        cost: report.cost.toString()
      }
    },
    submit () {
      this.isEditMode
        ? this.submitEditForm()
        : this.submitAddForm()
    },
    getDataForRequest () {
      const formData = new FormData()
      for (const key in this.form) {
        if (key === 'visual' && !this.form[key]) {
          continue
        }
        formData.append(key, this.form[key])
      }
      return formData
    },
    submitAddForm () {
      this.isAjaxLoaderVisible = true
      this.errors = {}
      this.isFormSubmitted = true
      apiAddReport({ data: this.getDataForRequest() }).then(() => {
        this.isFormSubmitted = false
        this.closeModal()
        this.$store.dispatch('reports/RETRIEVE_LIST')
        this.$snotify.success('', 'Raport został dodany')
      }).catch(err => {
        this.errors = err.response.data.response
        this.$snotify.error('', 'Formularz zawiera błędy')
      }).finally(() => {
        this.isAjaxLoaderVisible = false
      })
    },
    submitEditForm () {
      this.isAjaxLoaderVisible = true
      this.errors = {}
      this.isFormSubmitted = true
      apiEditReport({ id: this.reportId, data: this.getDataForRequest() }).then(() => {
        this.isFormSubmitted = false
        this.closeModal()
        this.$store.dispatch('reports/RETRIEVE_LIST')
        this.$snotify.success('', 'Zmiany zostały zapisane')
      }).catch(err => {
        this.errors = err.response.data.response
        this.$snotify.error('', 'Formularz zawiera błędy')
      }).finally(() => {
        this.isAjaxLoaderVisible = false
      })
    },
    resetData () {
      this.from = { ...initialFormData }
      this.errors = {}
      this.isFormSubmitted = false
      this.reportId = null
    }
  },
  components: {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    FormInput: () => import('@/components/form/Input'),
    FormInputAutocomplete: () => import('@/components/form/InputAutocomplete'),
    FormInputFile: () => import('@/components/form/InputFile'),
    FormDatePicker: () => import('@/components/form/DatePicker')
  }
}
</script>

<template>
  <mdb-modal :show="isModalVisible" @close="closeModal" scrollable class="reportFormModal">
    <div v-if="isAjaxLoaderVisible" class="spinner-wrapper">
      <div class="spinner spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <mdb-modal-header color="primary-color" textColor="white">
      <mdb-modal-title>{{ modalHeaderTitle }}</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body>
      <div class="report-form">
        
        <FormDatePicker
          v-model="form.date"
          :label="'Data'"
          :error="errors.date"
        />
        <FormInputAutocomplete
          v-model="form.supplier"
          :label="'Dostawca'"
          :error="errors.supplier"
          :data="suppliers"
        />
        <FormInputAutocomplete
          v-model="form.portal"
          :label="'Serwis'"
          :error="errors.portal"
          :data="portals"
        />
        <FormInputAutocomplete
          v-model="form.target"
          :label="'Target'"
          :error="errors.target"
          :data="targets"
        />
        <FormInputAutocomplete
          v-model="form.service"
          :label="'Usługa'"
          :error="errors.service"
          :data="services"
        />
        <FormInputAutocomplete
          v-model="form.product"
          :label="'Produkt'"
          :error="errors.product"
          :data="products"
        />
        <FormInput
          v-model="form.materials"
          :label="'NR CL'"
          :error="errors.materials"
          :isFormSubmitted="isFormSubmitted"
        />
        <!-- <FormInput
          v-if-"false"
          v-model="form.creation"
          :label="'Kreacja'"
          :error="errors.creation"
          :isFormSubmitted="isFormSubmitted"
        /> -->
        <FormInput
          v-model="form.title"
          :label="'Tytuł'"
          :error="errors.title"
          :isFormSubmitted="isFormSubmitted"
        />
        <FormInput
          v-model="form.display"
          :label="'Liczba wyświetleń'"
          :error="errors.display"
          :isFormSubmitted="isFormSubmitted"
        />
        <FormInput
          v-model="form.click"
          :label="'Kliki'"
          :error="errors.click"
          :isFormSubmitted="isFormSubmitted"
        />
        <FormInput
          v-model="form.open"
          :label="'Otwarcia'"
          :error="errors.open"
          :isFormSubmitted="isFormSubmitted"
        />
        <FormInput
          v-model="form.cost"
          :label="'Koszt'"
          :error="errors.cost"
          :isFormSubmitted="isFormSubmitted"
        />
        <FormInputFile
          v-model="form.visual"
          :label="'Screen / wizualizacja'"
          :error="errors.visual"
          :isFormSubmitted="isFormSubmitted"
          :preview-src="previewSrc"
        />
      </div>
    </mdb-modal-body>
    <mdb-modal-footer>
      <mdb-btn color="secondary" @click.native="closeModal">Anuluj</mdb-btn>
      <mdb-btn color="primary" @click="submit">Zapisz</mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<style lang="scss">
  .reportFormModal {
    .spinner-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0; 
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, .55);
      z-index: 50;
    }
  }
</style>
